import {Link as MuiLink} from '@mui/material';
import React, {forwardRef} from 'react';
import {Link as RouterLink} from 'react-router-dom';

const Link = forwardRef((props, ref) => {
  return <MuiLink ref={ref} component={RouterLink} {...props} />;
});

export default Link;
